module.exports = __webpack_public_path__ + "img/filter-intensity-high.a891a36a.svg";